import { render, staticRenderFns } from "./ImportTargets.vue?vue&type=template&id=071fd1ba"
import script from "./ImportTargets.vue?vue&type=script&lang=ts"
export * from "./ImportTargets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports